import { AppEnvironment } from '@dev-portal/environments';
import { baseEnvironmentValues, scope } from './config/base-environment-values';

const baseApiUrl: string = 'https://auth-stage0.stage.nursa.com/api';
const authServerUrl: string = 'https://auth-stage0.stage.nursa.com/oidc';

export const environment: AppEnvironment = {
  ...baseEnvironmentValues,
  stage: true,
  name: 'Stage',
  host: 'https://developers.stage.nursa.com',
  apiUrl: baseApiUrl,
  authServerUrl: authServerUrl,
  auth0Config: {
    domain: authServerUrl,
    clientId: 'oZz6w74YnCacpBlw9jth4iGDnUFupOJl',
    issuer: 'https://auth.stage.nursa.com/',
    useRefreshTokens: true,
    cacheLocation: 'localstorage',
    authorizationParams: {
      scope,
      redirect_uri: `${window.location.origin}`,
      audience: `https://public-api.stage.nursa.com/`
    },
    httpInterceptor: {
      allowedList: [{ uri: `${baseApiUrl}/*` }]
    }
  }
};
